<template>
  <div class="communication-evaluate">
    <div class="content view-box">
      <div class="title">满意度评价</div>
      <ul class="evaluate-radio" @click="clickHandler">
        <li
          v-for="(item, idx) in list"
          :key="item.value"
          :class="value === item.value ? 'active' : ''"
          :data-idx="idx"
        >
          <img
            :src="require('../../assets/img/communication/logo_wpxe.png')"
            class="img"
          />
          <span>{{ item.label }}</span>
        </li>
      </ul>
      <div class="title">评价内容</div>
      <field
        v-model="remark"
        rows="2"
        ref="field"
        autosize
        type="textarea"
        :maxlength="300"
        placeholder="写出您的服务感受，可以帮助更多商户哦~"
        show-word-limit
      />
    </div>
    <SHButton type="primary" size="large" @click="submitHandler">提交</SHButton>
  </div>
</template>

<script>
import 'vant/lib/field/style';

export default {
  name: 'Evaluate',

  mixins: [],

  components: {
    Field: () => import('vant/lib/field'),
    SHButton: () => import('@components/ShButton'),
  },

  props: {},

  data() {
    return {
      list: [
        { value: '1', label: '非常满意' },
        { value: '2', label: '比较满意' },
        { value: '3', label: '一般' },
        { value: '4', label: '不满意' },
        { value: '5', label: '非常不满意' },
      ],
      value: '1',
      remark: '',
    };
  },

  computed: {
    submitParams(vm) {
      return {
        value: vm.value,
        remark: vm.remark,
        id: vm.$route.query.id,
      };
    },
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    clickHandler(e) {
      const idx = e.target.getAttribute('data-idx');
      if (!idx) return;
      this.value = this.list[idx].value;
    },
    submitHandler() {
      this.$router.replace({
        name: 'communication-form',
      });
    },
  },
};
</script>

<style lang="less" scoped>
.communication-evaluate {
  width: 100%;
  background: #f4f4f4;
  padding: 9px 10px;
  box-sizing: border-box;
  .content {
    margin-bottom: 30px;
    padding: 16px 14px 24px;
    .title {
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 16px;
      text-align: left;
    }
    .evaluate-radio {
      display: flex;
      width: 100%;
      margin: 16px 0 31px;
      li {
        flex: 1;
        display: flex;
        flex-direction: column;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
        align-items: center;
        .img {
          width: 40px;
          height: 40px;
          margin-bottom: 6px;
        }
        &.active {
          font-weight: 500;
          color: #333333;
        }
      }
    }
    & /deep/ .van-field {
      width: 100%;
      height: 100px;
      border-radius: 4px;
      margin-top: 16px;
      border: 1px solid #cccccc;
      padding: 4px 9px 8px 8px;
      .van-field__value {
        display: flex;
        flex-direction: column;
        .van-field__word-limit {
          margin-top: 0;
          color: #ccc;
        }
        .van-field__body {
          flex: 1;
          .van-field__control {
            width: 100%;
            height: 100% !important;
          }
        }
      }
    }
  }
}
</style>
